module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "text-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'info'
    },
    on: {
      "click": function($event) {
        _vm.ActiveAccordion(_vm.ContainerActiveStatus)
      }
    }
  }, [_vm._v("Show Cont.")]), _vm._v(" "), _c('b-button', {
    staticClass: "text-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": 'info'
    },
    on: {
      "click": function($event) {
        _vm.ActiveTimelineAccordion(_vm.assActiveStatus)
      }
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), ((_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh')) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.extra_payment_flag == true &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.addExpense('')
      }
    }
  }, [_vm._v("Add / View Expenses")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.extra_payment_flag == true &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.addExpense('Lite')
      }
    }
  }, [_vm._v("Add Expenses New")]), _vm._v(" "), ((_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh')) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.extra_payment_flag == true &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalTask('')
      }
    }
  }, [_vm._v("Add Additional Task Request")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.extra_payment_flag == true &&
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalTask('Lite')
      }
    }
  }, [_vm._v("Additional Task(New)")]), _vm._v(" "), (_vm.enq_doc_master.length > 0) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showEnqDoc(_vm.showEnquiryTable)
      }
    }
  }, [_vm._v("\n      Show Enquiry Documents\n    ")]) : _vm._e(), _vm._v(" "), _c('Add-Message', {
    staticClass: "pull-right",
    staticStyle: {
      "list-style-type": "none"
    },
    attrs: {
      "fk_all_module_id": _vm.allModuleIdProp
    }
  }), _vm._v(" "), (_vm.assActiveStatus) ? _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.allModuleIdProp)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ContainerActiveStatus) ? _c('b-card', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Description")])]), _vm._v(" "), _vm._l((_vm.splitMergeContainerDetails), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "width": "20px"
      },
      attrs: {
        "bgcolor": "whiteSmoke",
        "scope": "row"
      }
    }, [_vm._v("\n              " + _vm._s(parseInt(idx + 1)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerNo))]), _vm._v(" "), _c('td', [(itm.splitedToOrMergedToAssigNo) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                Container Moved From :" + _vm._s(itm.fromSplitMergeAssignNo) + " to :\n                " + _vm._s(itm.splitedToOrMergedToAssigNo) + " (\n                "), (itm.isSplitedOrMergedNew == 1) ? _c('b', [_vm._v("Splited")]) : (itm.isSplitedOrMergedNew == 2) ? _c('b', [_vm._v("Merged")]) : (itm.isSplitedOrMergedNew == 3) ? _c('b', [_vm._v("Moved")]) : _vm._e(), _vm._v("\n                ) Updated Date(" + _vm._s(itm.split_merge_date_time) + ")\n              ")]) : _vm._e()])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  })]), _vm._v(" "), _vm._l((_vm.otherExpense), function(item, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.ledgerData,
        "option-value": "ledgerId",
        "option-text": "ledger",
        "placeholder": "Select "
      },
      model: {
        value: (item.ledgerId),
        callback: function($$v) {
          _vm.$set(item, "ledgerId", $$v)
        },
        expression: "item.ledgerId"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "amount",
        "name": "amount"
      },
      model: {
        value: (item.amount),
        callback: function($$v) {
          _vm.$set(item, "amount", $$v)
        },
        expression: "item.amount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1), _vm._v(" "), _c('td', [(!item.expenseId) ? _c('b-button', {
      staticClass: "mt-3",
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addExpenses(item)
        }
      }
    }, [_vm._v("Add\n                Expense")]) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [(_vm.showEnquiryTable) ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b', [_vm._v("Enq Documents - ENQ NO : " + _vm._s(_vm.enq_no))]), _vm._v(" "), _c('div', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("View")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.enq_doc_master), function(doc_item, doc_ind) {
    return _c('tr', {
      key: doc_ind
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(doc_ind + 1))]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(doc_item.doc_name)), _c('br'), _vm._v(" "), (doc_item.doc_created_date) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                    Added on " + _vm._s(doc_item.doc_created_date))]) : _vm._e(), _c('br'), (doc_item.createdBy || doc_item.updatedBy) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                    Created/Updated By\n                    " + _vm._s(doc_item.createdBy ? doc_item.createdBy : doc_item.updatedBy))]) : _vm._e()]), _vm._v(" "), _c('th', [(doc_item.doc_url) ? _c('div', _vm._l((doc_item.doc_url.split(',')), function(item1, index1) {
      return _c('span', {
        key: index1
      }, [(!doc_item.doc_url.includes('upload_pic')) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openSignedDocument('ASSIGNMENT_UPLOADS/' + _vm.enq_no.replaceAll('/', '_') + '/' + item1)
          }
        }
      }, [_vm._v("View Document - " + _vm._s(index1 + 1) + " "), _c('br')]) : _c('a', {
        attrs: {
          "href": _vm.docURL + "/" + item1,
          "target": "_blank",
          "download": ""
        }
      }, [_vm._v("View Document - " + _vm._s(index1 + 1) + "\n                        "), _c('br')])])
    })) : _vm._e()]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(doc_item.doc_remark))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b', [_vm._v("Summary")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper-scroll-y my-custom-scrollbar"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', _vm._l((_vm.showSumaryArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.value)
      }
    }, [_vm._v(_vm._s(item.value) + " Test")])])])
  }))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b', [_vm._v("Documents")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.downloadZip
    }
  }, [_vm._v("Download Zip")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper-scroll-y my-custom-scrollbar",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "scope": "col"
    }
  }, [(_vm.showAdd == true) ? _c('b-button', {
    attrs: {
      "disabled": (_vm.accountFlag ? false : (_vm.extra_payment_flag == true && _vm.$sessionsStorage.get('designation') != 'Admin' && _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false)),
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.addMoreDoc
    }
  }, [_vm._v("Add")]) : _vm._e()], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("View")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.docArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "\n                  "), (
      item.item != '' &&
      _vm.$sessionsStorage.get('designation') == 'Admin' &&
      _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.removeDoc(item)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.doc_master,
        "id": "clientNamenew",
        "option-value": "d_name",
        "option-text": "d_name",
        "placeholder": "Select"
      },
      model: {
        value: (item.documentName),
        callback: function($$v) {
          _vm.$set(item, "documentName", $$v)
        },
        expression: "item.documentName"
      }
    }), (item.docAddedDate) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                    Added on " + _vm._s(item.docAddedDate))]) : _vm._e(), _c('br'), (item.createdBy || item.updatedBy) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                    Created/Updated By\n                    " + _vm._s(item.createdBy ? item.createdBy : item.updatedBy))]) : _vm._e(), _c('br'), (item.documentName == 'Other') ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": item.addedFromMain == '0' ? true : false
      },
      model: {
        value: (item.otherDocName),
        callback: function($$v) {
          _vm.$set(item, "otherDocName", $$v)
        },
        expression: "item.otherDocName"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.documentLink && item.addedFromMain == '0') ? _c('div', _vm._l((item.documentLink.split(',')), function(item1, index1) {
      return _c('span', {
        key: index1
      }, [(!item.documentLink.includes('upload_pic')) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openSignedDocument('ASSIGNMENT_UPLOADS/' + _vm.JOBSERIES.replaceAll('/', '_') + '/' + item1)
          }
        }
      }, [_vm._v("View Document - " + _vm._s(index1 + 1) + " "), _c('br')]) : _c('a', {
        attrs: {
          "href": _vm.docURL + "/" + item1,
          "target": "_blank",
          "download": ""
        }
      }, [_vm._v("View Document - " + _vm._s(index1 + 1) + "\n                        "), _c('br')])])
    })) : (item.addedFromMain == '1') ? _c('div', [_c('td', [_c('div', [(_vm.doc_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.doc_err))]) : _vm._e(), _vm._v(" "), (!item.doc_id) ? _c('multi-file-uploader', {
      style: ("height: 79px;    background: darkgray;    width: 300px;"),
      attrs: {
        "documentName": 'Doc-',
        "otherDocName": 'Doc-',
        "folderName": 'Doc Library',
        "accept": '*',
        "assign_no": _vm.JOBSERIES,
        "multiple": true,
        "state": Boolean(_vm.singleUpload),
        "fileAllModuleId": _vm.allModuleIdProp
      },
      model: {
        value: (_vm.singleUpload),
        callback: function($$v) {
          _vm.singleUpload = $$v
        },
        expression: "singleUpload"
      }
    }) : _vm._e(), _vm._v(" "), (!item.doc_id) ? _c('span', [_vm._v("Choose a file or drop it above...")]) : _vm._e()], 1), _vm._v(" "), (item.documentLink) ? _c('div', _vm._l((item.documentLink.split(',')), function(item1, index1) {
      return _c('span', {
        key: index1
      }, [_c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.openSignedDocument('ASSIGNMENT_UPLOADS/' + _vm.JOBSERIES.replaceAll('/', '_') + '/' + item1)
          }
        }
      }, [_vm._v("View " + _vm._s(item1) + " - " + _vm._s(index1 + 1) + " "), _c('br')])])
    })) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": item.addedFromMain == '0' ? true : false
      },
      model: {
        value: (item.docRemarks),
        callback: function($$v) {
          _vm.$set(item, "docRemarks", $$v)
        },
        expression: "item.docRemarks"
      }
    }), (item.addedFromMain == '1' && !item.doc_id) ? _c('b-button', {
      staticClass: "pull-right mt-2",
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.submitDocment(index, item)
        }
      }
    }, [_vm._v("Upload")]) : _vm._e()], 1)])
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-700b860a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/docLibrary.vue
// module id = 2738
// module chunks = 0